<template>
  <div class="designer-profile">
    <!-- 导航栏 -->
    <van-nav-bar
      :title="designer.name"
      left-arrow
      fixed
      placeholder
      @click-left="$router.back()"
    >
      <!--      <template #right>-->
      <!--        <van-icon-->
      <!--          name="share-o"-->
      <!--          size="20"-->
      <!--          @click="handleShare"-->
      <!--        />-->
      <!--      </template>-->
    </van-nav-bar>

    <!-- 主要内容 -->
    <div class="profile-content">
      <!-- 头部信息区 -->
      <div class="profile-header">
        <!-- 封面图 -->
        <div class="cover-section">
          <img
            :src="designer.coverImage"
            alt="封面图"
            class="cover-image"
            @click="showCoverPreview = true"
          >
          <!--          <div class="cover-overlay">-->
          <!--            <van-button-->
          <!--              v-if="isFollowing"-->
          <!--              type="default"-->
          <!--              size="small"-->
          <!--              @click="handleUnfollow"-->
          <!--            >-->
          <!--              已关注-->
          <!--            </van-button>-->
          <!--            <van-button-->
          <!--              v-else-->
          <!--              type="primary"-->
          <!--              size="small"-->
          <!--              @click="handleFollow"-->
          <!--            >-->
          <!--              关注设计师-->
          <!--            </van-button>-->
          <!--          </div>-->
        </div>

        <!-- 头像和基本信息 -->
        <div class="basic-info-section">
          <div class="avatar-section">
            <img
              :src="designer.avatar"
              alt="设计师头像"
              class="designer-avatar"
            >
            <div
              v-if="designer.verified"
              class="verification-badge"
            >
              <van-icon
                name="certificate"
                color="#1989fa"
              />
            </div>
          </div>

          <div class="info-content">
            <h1 class="designer-name">
              {{ designer.name }}
            </h1>
            <p class="designer-bio">
              {{ designer.bio }}
            </p>

            <!-- 擅长领域标签 -->
            <div class="expertise-tags">
              <van-tag
                v-for="tag in designer.expertise"
                :key="tag"
                type="primary"
                size="medium"
                round
              >
                {{ tag }}
              </van-tag>
            </div>

            <!-- 基础数据 -->
            <div class="basic-stats">
              <div class="stat-item">
                <div class="stat-value">
                  {{ designer?.stats?.works }}
                </div>
                <div class="stat-label">
                  作品
                </div>
              </div>
              <div class="stat-item">
                <div class="stat-value">
                  {{ designer?.stats?.brands }}
                </div>
                <div class="stat-label">
                  合作品牌
                </div>
              </div>
<!--              <div class="stat-item">-->
<!--                <div class="stat-value">-->
<!--                  {{ designer?.stats?.followers }}-->
<!--                </div>-->
<!--                <div class="stat-label">-->
<!--                  关注-->
<!--                </div>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>

      <!-- 社交账号区域 -->
      <div class="social-accounts-section">
        <div class="section-header">
          <h3>关注设计师</h3>
          <span class="total-followers">{{ totalFollowers }} 粉丝</span>
        </div>

        <div class="social-platforms-grid">
          <div
            v-for="platform in activeSocialPlatforms"
            :key="platform.name"
            class="platform-card"
            @click="openSocialPlatform(platform)"
          >
            <div class="platform-header">
              <div class="platform-icon">
                <img
                  :src="getPlatformIcon(platform.name)"
                  :alt="platform.name"
                >
              </div>
              <div class="platform-info">
                <div class="platform-name">
                  {{ getPlatformDisplayName(platform.name) }}
                </div>
                <div class="account-handle">
                  @{{ platform.username }}
                </div>
              </div>
              <div
                v-if="platform.verified"
                class="verification-badge"
              >
                <van-icon
                  name="certificate"
                  color="#07c160"
                />
              </div>
            </div>

            <div class="platform-stats">
              <div class="stat">
                <div class="stat-value">
                  {{ formatNumber(platform.followers) }}
                </div>
                <div class="stat-label">
                  粉丝
                </div>
              </div>
              <div
                v-if="platform?.posts"
                class="stat"
              >
                <div class="stat-value">
                  {{ formatNumber(platform.posts) }}
                </div>
                <div class="stat-label">
                  内容
                </div>
              </div>
            </div>

            <div class="action-button">
              <van-button
                type="primary"
                size="mini"
                round
              >
                前往关注
              </van-button>
            </div>
          </div>
        </div>
      </div>

      <!-- 作品集区域 -->
      <div class="portfolio-section">
        <div class="section-header">
          <h3>代表作</h3>
          <router-link
            to="/designer/portfolio"
            class="view-all"
          >
            查看全部
          </router-link>
        </div>

        <div class="works-grid">
          <div
            v-for="work in featuredWorks"
            :key="work.id"
            class="work-card"
            @click="viewWorkDetail(work)"
          >
            <div class="work-image-container">
              <img
                :src="work.cover"
                :alt="work.title"
                class="work-image"
              >
              <div class="work-overlay">
                <div class="work-actions">
                  <van-icon name="eye-o" />
                  <span>{{ work.views }}</span>
                </div>
                <div class="work-actions">
                  <van-icon name="like-o" />
                  <span>{{ work.likes }}</span>
                </div>
              </div>
            </div>
            <div class="work-info">
              <div class="work-title">
                {{ work.title }}
              </div>
              <div class="work-meta">
                <span class="work-category">{{ work.category }}</span>
                <span class="work-year">{{ work.year }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 合作品牌区域 -->
      <div class="brands-section">
        <div class="section-header">
          <h3>合作品牌</h3>
        </div>
        <div class="brands-scroll">
          <div
            v-for="brand in designer?.portfolio?.collaborationBrands"
            :key="brand.id"
            class="brand-item"
          >
            <img
              :src="brand.logo"
              :alt="brand.name"
              class="brand-logo"
            >
            <span class="brand-name">{{ brand.name }}</span>
          </div>
        </div>
      </div>

      <!-- 最新动态 -->
      <div
        v-if="designer.updates && designer.updates.length > 0"
        class="updates-section"
      >
        <div class="section-header">
          <h3>最新动态</h3>
        </div>
        <div class="updates-list">
          <div
            v-for="update in designer.updates"
            :key="update.id"
            class="update-item"
          >
            <div class="update-type-tag">
              <van-tag
                :type="getUpdateTypeColor(update.type)"
                size="small"
              >
                {{ getUpdateTypeText(update.type) }}
              </van-tag>
            </div>
            <div class="update-content">
              {{ update.content }}
            </div>
            <div class="update-time">
              {{ formatUpdateTime(update.time) }}
            </div>
          </div>
        </div>
      </div>

      <!-- 联系合作按钮 -->
      <div class="cooperation-section">
        <van-button
          type="primary"
          block
          size="large"
          @click="handleCooperation"
        >
          联系合作
        </van-button>
      </div>
    </div>

    <!-- 封面图预览 -->
    <van-image-preview
      v-model:show="showCoverPreview"
      :images="[designer.coverImage]"
    />
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { showToast, showShareSheet } from 'vant'

export default {
  name: 'DesignerProfile',
  props: {
    designerId: {
      type: [String, Number],
      required: true
    }
  },
  setup (props) {
    const router = useRouter()

    // 测试数据
    const mockDesignerData = {
      id: 1,
      name: '设计师名',
      avatar: 'https://minio.zhuritec.com:29000/zhuritec-oss/86d447f2-6d36-46d1-8a68-e88ca8094f1e.png',
      coverImage: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&h=400&q=80',
      bio: '独立服装设计师，专注于现代简约风格。毕业于中央美术学院，曾任职于多个国际时尚品牌，致力于将东方美学与现代设计语言相融合。',
      expertise: ['服装设计', '面料研发', '品牌策划', '时尚摄影', '可持续时尚'],
      experience: 8,
      location: '上海',
      verified: true,
      stats: {
        works: 128,
        brands: 23,
        followers: 45600
      },
      socialAccounts: [
        {
          name: 'instagram',
          username: 'chenmubai_design',
          followers: 28500,
          posts: 234,
          verified: true,
          url: 'https://instagram.com/chenmubai_design'
        },
        {
          name: 'littleRedBook',
          username: '陈慕白设计工作室',
          followers: 13200,
          posts: 89,
          verified: true,
          url: 'https://xiaohongshu.com/user/profile/xxx'
        },
        {
          name: 'tengQuan',
          username: '慕白设计师',
          followers: 3800,
          posts: 45,
          verified: true,
          url: 'https://tengquan.com/designer/chenmubai'
        },
        {
          name: 'weibo',
          username: '陈慕白_Official',
          followers: 15600,
          posts: 567,
          verified: true,
          url: 'https://weibo.com/chenmubai'
        }
        // {
        //   name: 'behance',
        //   username: 'Chen Mubai',
        //   followers: 4200,
        //   posts: 34,
        //   verified: false,
        //   url: 'https://behance.net/chenmubai'
        // }
      ],
      portfolio: {
        featuredWorks: [
          {
            id: 1,
            title: '竹韵·春系列',
            cover: 'https://images.unsplash.com/photo-1595777457583-95e059d581b8?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=300&q=80',
            category: '女装系列',
            year: 2024,
            views: 12450,
            likes: 2356
          },
          {
            id: 2,
            title: '都市漫游者',
            cover: 'https://images.unsplash.com/photo-1539109136881-3be0616acf4b?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=300&q=80',
            category: '男装系列',
            year: 2023,
            views: 8920,
            likes: 1876
          },
          {
            id: 3,
            title: '月光丝绸礼服',
            cover: 'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=300&q=80',
            category: '高级定制',
            year: 2024,
            views: 15600,
            likes: 3120
          },
          {
            id: 4,
            title: '山海经联名系列',
            cover: 'https://images.unsplash.com/photo-1585487000128-2a62c7751b9c?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=300&q=80',
            category: '联名设计',
            year: 2023,
            views: 20300,
            likes: 4560
          },
          {
            id: 5,
            title: '可持续牛仔系列',
            cover: 'https://images.unsplash.com/photo-1541099649105-f69ad21f3246?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=300&q=80',
            category: '环保设计',
            year: 2024,
            views: 9800,
            likes: 1980
          },
          {
            id: 6,
            title: '传统刺绣现代演绎',
            cover: 'https://images.unsplash.com/photo-1582418702059-97ebafb35d09?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=300&q=80',
            category: '工艺创新',
            year: 2023,
            views: 11200,
            likes: 2670
          }
        ],
        collaborationBrands: [
          {
            id: 1,
            name: '品牌1',
            logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100&q=80'
          },
          {
            id: 2,
            name: '品牌2',
            logo: 'https://images.unsplash.com/photo-1548036328-c9fa89d128fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100&q=80'
          },
          {
            id: 3,
            name: '品牌3',
            logo: 'https://images.unsplash.com/photo-1560890625-93f0c42f0cb3?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100&q=80'
          },
          {
            id: 4,
            name: '品牌4',
            logo: 'https://images.unsplash.com/photo-1584917865442-de89df76afd3?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100&q=80'
          },
          {
            id: 5,
            name: '品牌5',
            logo: 'https://images.unsplash.com/photo-1595341888016-a392ef81b7de?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100&q=80'
          },
          {
            id: 6,
            name: '品牌6',
            logo: 'https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100&q=80'
          }
        ]
      },
      updates: [
        {
          id: 1,
          type: 'new_work',
          content: '刚刚发布了2024春夏系列「竹韵·春」，灵感来源于江南园林的竹影摇曳',
          time: '2024-01-15T10:30:00Z'
        },
        {
          id: 2,
          type: 'event',
          content: '将参加上海时装周2024春季展，展示最新可持续时尚系列',
          time: '2024-01-14T15:20:00Z'
        },
        {
          id: 3,
          type: 'media',
          content: '接受《Vogue》中国版专访，分享东方美学在现代设计中的应用',
          time: '2024-01-12T09:15:00Z'
        },
        {
          id: 4,
          type: 'award',
          content: '荣获2023年度中国时尚设计大奖「最佳女装设计奖」',
          time: '2024-01-10T14:45:00Z'
        },
        {
          id: 5,
          type: 'new_work',
          content: '与素然品牌合作推出联名系列「山海经」，融合传统神话与现代设计',
          time: '2024-01-08T11:30:00Z'
        }
      ]
    }

    // 响应式数据
    const designer = ref(mockDesignerData)
    const isFollowing = ref(false)
    const showCoverPreview = ref(false)

    // 平台图标映射
    const platformIcons = {
      instagram: 'https://img.icons8.com/ios-filled/50/instagram-new.png',
      littleRedBook: 'https://img.icons8.com/ios-filled/50/xiaohongshu.png',
      tengQuan: 'https://img.icons8.com/ios-filled/50/design.png',
      weibo: 'https://img.icons8.com/ios-filled/50/weibo.png',
      behance: 'https://img.icons8.com/ios-filled/50/behance.png',
      dribbble: 'https://img.icons8.com/ios-filled/50/dribbble.png'
    }

    // 平台显示名称映射
    const platformDisplayNames = {
      instagram: 'Instagram',
      littleRedBook: '小红书',
      tengQuan: '藤圈',
      weibo: '微博',
      behance: 'Behance',
      dribbble: 'Dribbble'
    }

    // 计算属性
    const totalFollowers = computed(() => {
      if (!designer.value.socialAccounts) return 0
      return designer.value.socialAccounts.reduce((total, platform) => {
        return total + (platform.followers || 0)
      }, 0)
    })

    const activeSocialPlatforms = computed(() => {
      if (!designer.value.socialAccounts) return []
      return designer.value.socialAccounts.filter(platform =>
        platform.username && platform.followers > 0
      )
    })

    const featuredWorks = computed(() => {
      if (!designer.value.portfolio?.featuredWorks) return []
      return designer.value.portfolio.featuredWorks.slice(0, 6)
    })

    // 方法
    const getPlatformIcon = (platformName) => {
      return platformIcons[platformName] || 'https://img.icons8.com/ios-filled/50/domain.png'
    }

    const getPlatformDisplayName = (platformName) => {
      return platformDisplayNames[platformName] || platformName
    }

    const formatNumber = (num) => {
      if (!num) return '0'
      if (num >= 100000000) {
        return (num / 100000000).toFixed(1) + '亿'
      }
      if (num >= 10000) {
        return (num / 10000).toFixed(1) + 'w'
      }
      if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'k'
      }
      return num.toString()
    }

    const openSocialPlatform = (platform) => {
      if (platform.url && platform.url.startsWith('http')) {
        window.open(platform.url, '_blank')
      } else {
        showToast('平台链接暂不可用')
      }
    }

    const viewWorkDetail = (work) => {
      router.push(`/work/${work.id}`)
    }

    const handleFollow = async () => {
      try {
        // 模拟API调用
        await new Promise(resolve => setTimeout(resolve, 500))
        isFollowing.value = true
        designer.value.stats.followers++
        showToast('关注成功')
      } catch (error) {
        showToast('关注失败')
      }
    }

    const handleUnfollow = async () => {
      try {
        // 模拟API调用
        await new Promise(resolve => setTimeout(resolve, 500))
        isFollowing.value = false
        designer.value.stats.followers--
        showToast('已取消关注')
      } catch (error) {
        showToast('取消关注失败')
      }
    }

    const handleShare = () => {
      showShareSheet({
        options: [
          { name: '微信', icon: 'wechat' },
          { name: '微博', icon: 'weibo' },
          { name: '复制链接', icon: 'link' }
        ]
      })
    }

    const handleCooperation = () => {
      router.push({
        path: '/cooperation/inquiry',
        query: { designerId: props.designerId }
      })
    }

    const getUpdateTypeColor = (type) => {
      const colors = {
        new_work: 'primary',
        event: 'success',
        media: 'warning',
        award: 'danger'
      }
      return colors[type] || 'default'
    }

    const getUpdateTypeText = (type) => {
      const texts = {
        new_work: '新作',
        event: '活动',
        media: '媒体',
        award: '获奖'
      }
      return texts[type] || '动态'
    }

    const formatUpdateTime = (time) => {
      const date = new Date(time)
      const now = new Date()
      const diff = now - date

      const days = Math.floor(diff / (1000 * 60 * 60 * 24))
      if (days > 0) return `${days}天前`

      const hours = Math.floor(diff / (1000 * 60 * 60))
      if (hours > 0) return `${hours}小时前`

      const minutes = Math.floor(diff / (1000 * 60))
      if (minutes > 0) return `${minutes}分钟前`

      return '刚刚'
    }

    // 初始化数据
    onMounted(() => {
      // 在实际项目中，这里会调用API获取设计师数据
      console.log('设计师档案页面加载完成，设计师ID:', props.designerId)
    })

    return {
      designer,
      isFollowing,
      showCoverPreview,
      totalFollowers,
      activeSocialPlatforms,
      featuredWorks,
      getPlatformIcon,
      getPlatformDisplayName,
      formatNumber,
      openSocialPlatform,
      viewWorkDetail,
      handleFollow,
      handleUnfollow,
      handleShare,
      handleCooperation,
      getUpdateTypeColor,
      getUpdateTypeText,
      formatUpdateTime
    }
  }
}
</script>

<style lang="scss" scoped>
.designer-profile {
  min-height: 100vh;
  background-color: #f7f8fa;
}

.profile-content {
  padding: 0 0 20px;
}

// 头部信息区样式
.profile-header {
  background: white;
  margin-bottom: 12px;

  .cover-section {
    position: relative;
    height: 200px;
    overflow: hidden;

    .cover-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .cover-overlay {
      position: absolute;
      bottom: 16px;
      right: 16px;
    }
  }

  .basic-info-section {
    padding: 0 16px 20px;
    position: relative;
    margin-top: -40px;

    .avatar-section {
      position: relative;
      display: inline-block;

      .designer-avatar {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: 4px solid white;
        background: white;
      }

      .verification-badge {
        position: absolute;
        bottom: 4px;
        right: 4px;
        background: white;
        border-radius: 50%;
        padding: 2px;
      }
    }

    .info-content {
      margin-top: 22px;

      .designer-name {
        margin: 0 0 8px;
        font-size: 20px;
        font-weight: 600;
        color: #1e293b;
      }

      .designer-bio {
        margin: 0 0 12px;
        color: #64748b;
        font-size: 14px;
        line-height: 1.5;
      }

      .expertise-tags {
        margin-bottom: 16px;

        .van-tag {
          margin-right: 8px;
          margin-bottom: 8px;
        }
      }

      .basic-stats {
        display: flex;
        gap: 24px;

        .stat-item {
          text-align: center;

          .stat-value {
            font-size: 18px;
            font-weight: 600;
            color: #1e293b;
          }

          .stat-label {
            font-size: 12px;
            color: #64748b;
            margin-top: 4px;
          }
        }
      }
    }
  }
}

// 社交账号区域样式
.social-accounts-section {
  background: white;
  padding: 16px;
  margin-bottom: 12px;
  border-radius: 8px;

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #1e293b;
    }

    .total-followers {
      font-size: 14px;
      color: #64748b;
    }
  }

  .social-platforms-grid {
    display: grid;
    gap: 12px;
  }

  .platform-card {
    padding: 16px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      border-color: #3b82f6;
      box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
    }

    .platform-header {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      .platform-icon {
        width: 32px;
        height: 32px;
        margin-right: 12px;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .platform-info {
        flex: 1;

        .platform-name {
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          margin-bottom: 2px;
        }

        .account-handle {
          font-size: 12px;
          color: #64748b;
        }
      }

      .verification-badge {
        margin-left: 8px;
      }
    }

    .platform-stats {
      display: flex;
      gap: 16px;
      margin-bottom: 12px;

      .stat {
        text-align: center;

        .stat-value {
          font-size: 14px;
          font-weight: 600;
          color: #1e293b;
        }

        .stat-label {
          font-size: 11px;
          color: #64748b;
          margin-top: 2px;
        }
      }
    }

    .action-button {
      text-align: center;
    }
  }
}

// 作品集区域样式
.portfolio-section {
  background: white;
  padding: 16px;
  margin-bottom: 12px;
  border-radius: 8px;

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #1e293b;
    }

    .view-all {
      font-size: 14px;
      color: #3b82f6;
      text-decoration: none;
    }
  }

  .works-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .work-card {
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;

    .work-image-container {
      position: relative;
      aspect-ratio: 1;
      overflow: hidden;

      .work-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease;
      }

      .work-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.4);
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        padding: 8px;
        opacity: 0;
        transition: opacity 0.3s ease;

        .work-actions {
          display: flex;
          align-items: center;
          color: white;
          font-size: 12px;

          .van-icon {
            margin-right: 4px;
          }
        }
      }

      &:hover {
        .work-image {
          transform: scale(1.05);
        }

        .work-overlay {
          opacity: 1;
        }
      }
    }

    .work-info {
      padding: 8px;

      .work-title {
        font-size: 14px;
        font-weight: 500;
        color: #1e293b;
        margin-bottom: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .work-meta {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: #64748b;
      }
    }
  }
}

// 合作品牌区域样式
.brands-section {
  background: white;
  padding: 16px;
  margin-bottom: 12px;
  border-radius: 8px;

  .section-header {
    margin-bottom: 16px;

    h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #1e293b;
    }
  }

  .brands-scroll {
    display: flex;
    overflow-x: auto;
    gap: 16px;
    padding-bottom: 8px;

    &::-webkit-scrollbar {
      display: none;
    }

    .brand-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      min-width: 80px;

      .brand-logo {
        width: 60px;
        height: 60px;
        border-radius: 8px;
        object-fit: contain;
        margin-bottom: 8px;
        background: #f8fafc;
        padding: 8px;
      }

      .brand-name {
        font-size: 12px;
        color: #64748b;
        text-align: center;
      }
    }
  }
}

// 最新动态区域样式
.updates-section {
  background: white;
  padding: 16px;
  margin-bottom: 12px;
  border-radius: 8px;

  .section-header {
    margin-bottom: 16px;

    h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #1e293b;
    }
  }

  .updates-list {
    .update-item {
      display: flex;
      align-items: flex-start;
      padding: 12px 0;
      border-bottom: 1px solid #f1f5f9;

      &:last-child {
        border-bottom: none;
      }

      .update-type-tag {
        margin-right: 12px;
        flex-shrink: 0;
      }

      .update-content {
        flex: 1;
        font-size: 14px;
        color: #374151;
        line-height: 1.5;
      }

      .update-time {
        font-size: 12px;
        color: #94a3b8;
        margin-left: 12px;
        flex-shrink: 0;
      }
    }
  }
}

// 合作按钮区域样式
.cooperation-section {
  padding: 0 16px;
  margin-top: 20px;
}

// 响应式设计
@media (min-width: 768px) {
  .profile-content {
    max-width: 800px;
    margin: 0 auto;
    padding: 0 20px 40px;
  }

  .social-platforms-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .works-grid {
    grid-template-columns: repeat(3, 1fr) !important;
  }

  .profile-header .cover-section {
    height: 300px;
  }

  .profile-header .basic-info-section {
    display: flex;
    align-items: flex-start;

    .avatar-section {
      margin-right: 20px;
    }

    .info-content {
      flex: 1;
      margin-top: 0;
    }
  }
}

@media (min-width: 1024px) {
  .works-grid {
    grid-template-columns: repeat(4, 1fr) !important;
  }

  .social-platforms-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
